<template>
  <b-row class="mt-4">
    <b-col :sm="sm" :md="md" :offset-md="mdOffset">
      <div class="summary" v-html="text">
        <!--{{text}}-->
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'SectionSummary',
  props: {
    text: {
      type: String,
      default: ''
    },
    sm: {
      type: String,
      default: '12'
    },
    md: {
      type: String,
      default: '8'
    },
    mdOffset: {
      type: String,
      default: '2'
    }
  }
}

</script>

<style scoped>

.summary {
  text-align: center;
  font-weight:500;
}

</style>



// WEBPACK FOOTER //
// src/components/text/SectionSummary.vue